import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let sifLoginMountPromise = null;

export function initSifLoginViewFragment({ onMounted } = {}) {
  registerViewMount('admin-sif-login', () => mountSifLoginView(onMounted));
}

async function mountSifLoginView(onMounted) {
  if (document.getElementById('view-admin-sif-login')) return;
  if (sifLoginMountPromise) return sifLoginMountPromise;

  sifLoginMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');
    await appendTrustedAdminViewFragment(host, '/admin-views/sif-login.html', 'Unable to load SIF login view');
    onMounted?.();
  })();

  try {
    await sifLoginMountPromise;
  } catch (error) {
    sifLoginMountPromise = null;
    throw error;
  }
}
